import { useState, useEffect } from 'react';

export function useHasMounted(enabled = true) {
    const [hasMounted, setHasMounted] = useState(false);
    useEffect(() => {
        if (enabled) setHasMounted(true);
    }, [enabled]);
    return enabled ? hasMounted : true;
}
